import { render, staticRenderFns } from "./UsersProfilesForm.vue?vue&type=template&id=6a029a2d"
import script from "./UsersProfilesForm.vue?vue&type=script&lang=js"
export * from "./UsersProfilesForm.vue?vue&type=script&lang=js"
import style0 from "./UsersProfilesForm.vue?vue&type=style&index=0&id=6a029a2d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports